import React, { useEffect, useRef, useState } from "react";
import { Button, CircularProgress, Modal } from "@material-ui/core";
import stylesPc from "./DirectoryIndex.module.css";
import stylesSp from "./DirectoryIndex_SP.module.css";
import CreateDirectoryModal from "./CreateDirectoryModal";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import {
    GetDir,
    DeleteDir,
    UploadFootage,
    DeleteFootage,
} from "../../store/actions/DirectoryActions";
import { useInitFlag } from "../../../components/function/useInitFlag";
import PuiTypography from "../../../components/elements/PuiTypography";
import TimelineTopMenuArea from "../timelineTop/TimelineTopMenuArea";
import TimelineTopModal from "../timelineTop/TimelineTopModal";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { useInitText } from "../../../components/function/useInitText";
import { GetFootageUrlFromId } from "../../../utils/TimelineUtils";
import DirectoryList from "./DirectoryList";
import { useInitNumber } from "../../../components/function/useInitNumber";
import RenameObjectModal from "../../../common/components/modal/RenameObjectModal";
import DirectoryPath from "./DirectoryPath";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import { t } from "i18next";

function DirectoryIndex() {
    const dispatch = useDispatch();
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    // Storeからデータ取得
    const { user, directoryList, footageList, isLoadingUploadFootage } = useSelector(
        (state: AppState) => ({
            user: state.user.userInfo,
            directoryList: state.directory.directoryList,
            footageList: state.directory.footageList,
            isLoadingUploadFootage: state.timeline.isLoadingUploadFootage,
        })
    );
    const directoryRef = useRef<HTMLTableElement | null>(null);

    // フォルダー名リスト定義
    const [selectedPathList, setSelectedPathList] = useState<any[]>([
        { id: 0, name: t("メディア") },
    ]);

    const inputFootage = useRef<HTMLInputElement>(null);

    const [footageUrl, setFootageUrl] = useState<string>("");
    const [footageStatus, setFootageStatus] = useInitText();

    // メニューボタンを押下の場合、
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [isOpenFolderModal, setIsOpenFolderModal] = useState<boolean>(false);

    // フッテージプレビュー
    const [visiblePreviewModal, ShowPreviewModal] = useInitFlag(false);

    // フォルダー名変更処理
    const [editFolderId, setEditFolderId] = useState(0);
    const [editFolderName, setEditFolderName] = useState("");
    // フッテージ名変更処理
    const [editFootageId, setEditFootageId] = useInitNumber();
    const [editFootageName, setEditFootageName] = useInitText();

    // フォルダ名編集ポップアップ表示フラグ
    const [isOpenRenameFootageModal, setOpenRenameFootageModal] = useInitFlag();

    // フォルダーor フッテージ削除処理
    const [isOpenVerifyDeleteModal, ShowVerifyDeleteModal] = useState(false);
    const [isOpenVerifyDeleteFolderModal, ShowVerifyDeleteFolderModal] = useState(false);
    const [deleteId, setDeleteId] = useState(-1);

    // 書き出し失敗・完了メッセージ
    const [showExportSuccessMessage, setShowExportSuccessMessage] = useInitFlag();

    // 現在のディレクトリ
    const [currentDirectory, setCurrentDirectory] = useState<{ id: number; name: string }>({
        id: 0,
        name: t("メディア"),
    });

    // 履歴用
    const [selectedHistoryPathList, setSelectedhistoryPathList] = useState<
        { id: number; name: string }[]
    >([{ id: 0, name: t("メディア") }]);

    useEffect(() => {
        if (user) {
            // ディレクトリ一覧取得APIコール
            dispatch(GetDir(0, Number(user.id)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    // アップロードステータス状況取得
    useEffect(() => {
        let IS_UPLOADING = false;
        let timeoutId: NodeJS.Timeout;
        if (footageList && footageList.length > 0) {
            IS_UPLOADING = footageList.some((footage) => footage.status === "UPLOADING");

            if (IS_UPLOADING && user) {
                timeoutId = setTimeout(
                    () => dispatch(GetDir(currentDirectory.id, Number(user.id))),
                    5000
                );
            }
        }
        // クリーンアップ
        return () => {
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line
    }, [footageList]);

    // 新規フォルダボタン押下時
    const handleMenuClick = () => {
        setEditFolderId(0);
        setEditFolderName("");
        setIsOpenFolderModal(true);
    };

    // メニューボタンを再押下の場合、
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // フッテージクリックでプレビューモーダル表示
    const handleClickFootage = (footageId: number, status: string) => {
        setFootageUrl(GetFootageUrlFromId(footageId));
        setFootageStatus(status);
        ShowPreviewModal(true);
    };

    //プレビューmodalを閉じる処理
    const handleClosePreviewModal = () => {
        ShowPreviewModal(false);
    };

    // 名前を変更ボタン押下時
    const handleEditFolder = (id: number, name: string) => {
        setEditFolderId(id);
        setEditFolderName(name);
        // フォルダー名変更するモーダルを呼び出す
        setIsOpenFolderModal(true);
    };

    // メッセージを閉じる
    const closeExportSuccessMsg = () => {
        setShowExportSuccessMessage(false);
    };

    // 削除ボタン押下時
    const handleDeleteFolder = (id: number, hasDir: boolean) => {
        OpenVerifyDeleteFolderModal();
        setDeleteId(id);
    };

    // フッテージ名変更
    const handleEditFootage = (id: number, name: string) => {
        setEditFootageId(id);
        setEditFootageName(name);
        // フッテージ名変更するモーダルを呼び出す
        setOpenRenameFootageModal(true);
    };

    //フッテージ削除ボタン押下時
    const handleDeleteFootage = (id: number) => {
        OpenVerifyDeleteModal();
        setDeleteId(id);
    };

    // フッテージ削除モーダルを表示
    const OpenVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(true);
    };

    // フォルダー削除モーダルを表示
    const OpenVerifyDeleteFolderModal = () => {
        ShowVerifyDeleteFolderModal(true);
    };

    // 削除モーダルを閉じる
    const CloseVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(false);
        ShowVerifyDeleteFolderModal(false);
        setDeleteId(-1);
    };

    // モーダルのキャンセルボタンを押下の場合、
    const handleCancelDelete = () => {
        CloseVerifyDeleteModal();
    };

    // フッテージアイテムを押下の場合、
    const handleMenufootageClick = () => {
        // フッテージを選択できるファイルエクスプローラ表示
        inputFootage.current?.click();
        handleMenuClose();
    };

    // ディレクトリ削除処理
    const handleDirectoryDelete = () => {
        if (user) {
            dispatch(DeleteDir(deleteId, true, Number(user.id)));
        }
        CloseVerifyDeleteModal();
    };

    // footage削除処理
    const handleFootageDelete = () => {
        if (user) {
            dispatch(
                DeleteFootage(
                    deleteId,
                    Number(user.id),
                    selectedPathList[selectedPathList.length - 1].id
                )
            );
        }
        CloseVerifyDeleteModal();
    };

    // フッテージアップロード処理
    const uploadFootage = (event: any) => {
        // 選択したフッテージファイルがある場合、
        if (event.target.files.length === 1 && !isLoadingUploadFootage) {
            if (user) {
                dispatch(
                    UploadFootage(
                        event.target.files[0],
                        removeExtension(event.target.files[0].name),
                        selectedPathList[selectedPathList.length - 1].id,
                        Number(user.id)
                    )
                );
            }
            setShowExportSuccessMessage(true);
        }
    };

    // 作成済のフォルダーを選択した場合、
    const clickFolder = (id: number, name: string) => {
        // ディレクトリ一覧取得APIコール
        if (user) dispatch(GetDir(id, Number(user.id)));
        // 表示するディレクトリ
        setCurrentDirectory({ id, name });
        // rootからディレクトリが変わったかの判断
        const isDirectory = selectedHistoryPathList.some((path) => {
            return path.id === id;
        });
        //履歴用の配列
        let tempSelectHistoryPathList: any[] = [];
        if (selectedPathList.length === 1 && !isDirectory && selectedHistoryPathList.length > 1) {
            tempSelectHistoryPathList = [{ id: 0, name: t("メディア") }];
        } else {
            tempSelectHistoryPathList = selectedHistoryPathList;
        }
        tempSelectHistoryPathList.push({
            id: id,
            name: name,
        });
        // 履歴用の配列に保存
        setSelectedhistoryPathList(tempSelectHistoryPathList);

        // 選択したフォルダーID・フォルダー名を配列に保存
        setSelectedPathList([
            ...selectedPathList,
            {
                id: id,
                name: name,
            },
        ]);
        if (!directoryRef || !directoryRef.current) return;
        directoryRef.current.scrollTop = 0;
    };

    // 拡張子なしのファイル名を設定する。
    const removeExtension = (filename: string) => {
        const lastDotPosition = filename.lastIndexOf(".");
        if (lastDotPosition === -1) return filename;
        else return filename.substring(0, lastDotPosition);
    };

    return (
        <div className={styles.root}>
            <div className={styles.row}>
                <TimelineTopMenuArea menuType="メディア" />
                <div className={styles.container} id="container">
                    {/* フォルダー名表示 */}
                    <div className={styles.header}>
                        <DirectoryPath
                            selectedHistoryPathList={selectedHistoryPathList}
                            setSelectedhistoryPathList={setSelectedhistoryPathList}
                            directoryList={directoryList}
                            selectedPathList={selectedPathList}
                            setSelectedPathList={setSelectedPathList}
                            setCurrentDirectory={setCurrentDirectory}
                            currentDirectory={currentDirectory}
                            directoryRef={directoryRef}
                        />
                        {/* フッテージ作成メニュー表示 */}
                        <Button
                            onClick={handleMenufootageClick}
                            className={styles.footageBtn}
                            disabled={selectedPathList.length === 1}
                            style={{
                                opacity: selectedPathList.length === 1 ? "0.2" : 1,
                            }}
                        >
                            <div className={styles.footageUploadBtn} />
                        </Button>
                        {/* フッテージアップロード用 */}
                        <input
                            type="file"
                            accept="video/*"
                            style={{ display: "none" }}
                            ref={inputFootage}
                            onChange={uploadFootage}
                        />
                        <Button
                            id="customized-button"
                            aria-controls={open ? "customized-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                            variant="contained"
                            disableElevation
                            onClick={handleMenuClick}
                            className={styles.btnDiv}
                            style={{
                                backgroundColor: "var(--gray-38)",
                                color: "var(--white)",
                                fontFamily: "noto-sans-cjk-jp",
                            }}
                        >
                            {t("新規フォルダー")}
                        </Button>
                    </div>
                    <DirectoryList
                        directoryList={directoryList}
                        footageList={footageList}
                        clickFolder={clickFolder}
                        handleEditFolder={handleEditFolder}
                        handleDeleteFolder={handleDeleteFolder}
                        handleClickFootage={handleClickFootage}
                        handleEditFootage={handleEditFootage}
                        handleDeleteFootage={handleDeleteFootage}
                        directoryRef={directoryRef}
                    />
                    {/* フォルダー作成モーダルを呼び出す */}
                    <CreateDirectoryModal
                        openCreateFolderModal={isOpenFolderModal}
                        setOpenCreateFolderModal={setIsOpenFolderModal}
                        createdFolderId={selectedPathList[selectedPathList.length - 1].id}
                        editFolderId={editFolderId}
                        editFolderName={editFolderName}
                        setEditFolderName={setEditFolderName}
                    />
                    {/* 動画プレビュー再生モーダル */}
                    <Modal
                        open={visiblePreviewModal}
                        onClose={handleClosePreviewModal}
                        className={styles.previewModal}
                    >
                        <>
                            {(footageStatus?.toLowerCase() === "uploading" ||
                                footageStatus?.toLowerCase() === "error") && (
                                <div className={styles.errorDiv}>
                                    {footageStatus?.toLowerCase() === "error"
                                        ? t(
                                              "エラーが発生しました。メディアを再度アップロードしてください。"
                                          )
                                        : t(
                                              "この動画は処理中です。しばらくしてから再度ご確認ください。"
                                          )}
                                </div>
                            )}
                            <video
                                autoPlay
                                controls
                                controlsList="nofullscreen nodownload"
                                disablePictureInPicture
                            >
                                <source src={footageUrl} type="video/mp4" />
                            </video>
                        </>
                    </Modal>
                    {/* フッテージ名変更モーダルを呼び出す */}
                    <RenameObjectModal
                        isOpenModal={isOpenRenameFootageModal}
                        setOpenModal={setOpenRenameFootageModal}
                        id={editFootageId}
                        editName={editFootageName}
                        setEditName={setEditFootageName}
                        type={t("フッテージ")}
                    />
                    {/* フォルダー削除確認モーダル表示 */}
                    <TimelineTopModal
                        message={t("フォルダーを削除しますか？")}
                        leftButtonText={t("キャンセル")}
                        rightButtonText={t("削除")}
                        leftButtonClick={handleCancelDelete}
                        rightButtonClick={handleDirectoryDelete}
                        open={isOpenVerifyDeleteFolderModal}
                        onClose={CloseVerifyDeleteModal}
                    />
                    {/* フッテージ削除確認モーダル表示 */}
                    <TimelineTopModal
                        message={t("フッテージを削除しますか？")}
                        leftButtonText={t("キャンセル")}
                        rightButtonText={t("削除")}
                        leftButtonClick={handleCancelDelete}
                        rightButtonClick={handleFootageDelete}
                        open={isOpenVerifyDeleteModal}
                        onClose={handleCancelDelete}
                    />
                    <PuiMessage
                        open={showExportSuccessMessage}
                        type="info"
                        title={t("この動画は処理中です。しばらくしてから再度ご確認ください。")}
                        duration={3000}
                        onClose={closeExportSuccessMsg}
                    />
                    {/* フッテージアップロードモーダル表示 */}
                    <Modal open={isLoadingUploadFootage}>
                        <div className={styles.noContent}>
                            <CircularProgress
                                size={60}
                                style={{ color: "var(--loading-bg)", marginBottom: "15px" }}
                            />
                            <div className={styles.text}>
                                <PuiTypography>{t("アップロード中です・・・")}</PuiTypography>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
    );
}

export default DirectoryIndex;
